import { IOrderStageUseCase, IOrderStage } from "@lib";
import { IOrderStageCreateDto, IOrderStageUpdateDto } from "@lib";
import { DataLoadException } from "@/core/exceptions";
import { Api } from "../axios";

export class OrderStageUseCase implements IOrderStageUseCase {
    public async select(companyId: string): Promise<IOrderStage[]> {
        try {
            const response = await Api.get<IOrderStage[]>(`/companies/${companyId}/lists/orderstages`);
            return response.data;
        } catch (e: any) {
            throw new DataLoadException(e);
        }
    }

    public async get(companyId: string, id: string): Promise<IOrderStage> {
        try {
            const response = await Api.get<IOrderStage>(`/companies/${companyId}/lists/orderstages/${id}`);
            return response.data;
        } catch (e: any) {
            throw new DataLoadException(e);
        }
    }

    public async create(companyId: string, dto: IOrderStageCreateDto): Promise<IOrderStage> {
        try {
            const response = await Api.post<IOrderStage>(`/companies/${companyId}/lists/orderstages`, dto);
            return response.data;
        } catch (e: any) {
            throw new DataLoadException(e);
        }
    }

    public async createMany(companyId: string, dtos: IOrderStageCreateDto[]): Promise<IOrderStage[]> {
        try {
            const response = await Api.post<IOrderStage[]>(`/companies/${companyId}/lists/orderstages/many`, dtos);
            return response.data;
        } catch (e: any) {
            throw new DataLoadException(e);
        }
    }

    public async update(companyId: string, id: string, dto: IOrderStageUpdateDto): Promise<IOrderStage> {
        try {
            const response = await Api.put<IOrderStage>(`/companies/${companyId}/lists/orderstages/${id}`, dto);
            return response.data;
        } catch (e: any) {
            throw new DataLoadException(e);
        }
    }

    public async archive(companyId: string, id: string): Promise<void> {
        try {
            await Api.delete<void>(`/companies/${companyId}/lists/orderstages/${id}`);
        } catch (e: any) {
            throw new DataLoadException(e);
        }
    }
}
